(() => {
  const inner = document.querySelector('.plp-heading-main__inner');
  if (!inner) return;

  const setHeightVar = () => {
    document.documentElement.style.setProperty('--plp-heading-main-inner-height', `${inner.getBoundingClientRect().height}px`);
  };

  setHeightVar();

  if ('ResizeObserver' in window) {
    new ResizeObserver(setHeightVar).observe(inner);
  } else {
    window.addEventListener('resize', setHeightVar);
  }

  window.addEventListener('load', setHeightVar, { once: true });
})();
